import styled, { keyframes } from "styled-components";
import { getColor, responsive } from "~/helpers/style";
import { sidebarWidth } from "~/components/layout/Sidebar.style";

/* ── Banner (sticky bottom-left card) ── */

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const BannerWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  left: 24px;
  z-index: 999;
  width: 320px;
  background: #2d2d3d;
  border-radius: 12px;
  padding: 20px;
  color: #ffffff;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  animation: ${slideUp} 0.4s ease-out;

  ${responsive("tablet")} {
    left: ${sidebarWidth + 24}px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  opacity: 1;
  padding: 4px;
  font-size: 16px;
  line-height: 1;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    color: #555;
    cursor: default;
    opacity: 0.3;

    &:hover {
      opacity: 0.3;
    }
  }
`;

export const Title = styled.h3`
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  padding-right: 24px;
`;

export const Description = styled.p`
  margin: 0 0 16px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.7);
`;

export const ClaimButton = styled.button`
  width: 100%;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  background: #ffffff;
  color: #2d2d3d;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease-in-out;

  &:hover {
    filter: brightness(0.95);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

/* ── Confirmation Modal ── */

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(8, 14, 40, 0.55);
  padding: 24px;
`;

export const ModalCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: min(520px, 100%);
  padding: 32px;
  border-radius: 12px;
  background: #ffffff;
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  color: ${getColor("textSecondary")};
  cursor: pointer;
  padding: 4px;
  font-size: 18px;
  line-height: 1;
  transition: color 0.15s;

  &:hover {
    color: ${getColor("text")};
  }
`;

export const ModalTitle = styled.h2`
  margin: 0;
  color: ${getColor("text")};
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
`;

export const ModalDescription = styled.p`
  margin: 0;
  color: ${getColor("textSecondary")};
  font-size: 14px;
  line-height: 1.6;
`;

export const TestimonialRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #f5f5f8;
  border-radius: 8px;
`;

export const TestimonialAvatar = styled.div`
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${getColor("primaryLight")};
`;

export const TestimonialText = styled.p`
  margin: 0;
  font-size: 13px;
  font-style: italic;
  color: ${getColor("textSecondary")};
  line-height: 1.5;
`;

export const CardSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border: 1px solid ${getColor("border")};
  border-radius: 8px;
`;

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CardLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${getColor("text")};
`;

export const CardDigits = styled.span`
  font-size: 13px;
  color: ${getColor("textSecondary")};
`;

export const ChangeCardLink = styled.button`
  background: none;
  border: none;
  color: ${getColor("primary")};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;

export const ConfirmButton = styled.button`
  width: 100%;
  padding: 14px 24px;
  border: none;
  border-radius: 8px;
  background: ${getColor("primary")};
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.1s ease-in-out;

  &:hover {
    filter: brightness(0.95);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
